"use client";

import React from "react";
import { reportsData } from "../../utils/reportsData";

const AgentPerformanceTable = ({ onAgentSelect }) => {
  const agents = reportsData.agent_performance;

  const handleViewDetails = (agent) => {
    if (onAgentSelect) {
      onAgentSelect(agent);
    }
  };

  return (
    <div className="w-full">
      <h2 className="text-[13px] font-semibold leading-[100%] text-black font-inter mb-4">
        Agent Performance
      </h2>

      <div className="w-full shadow-[4px_4px_47.1px_0px_#00000040] rounded-[10px] px-1 pt-1 overflow-hidden bg-white">
        {/* Table Header */}
        <div className="w-full h-[40px] text-center bg-[#F6F9FF] border border-[#00000029] rounded-[10px] flex items-center px-4">
          <div className="md:text-[12px] text-[11px] font-normal text-black font-inter w-full text-left">
            Agent Name
          </div>
          <div className="md:text-[12px] text-[11px] font-normal text-black font-inter w-full text-center">
            Role
          </div>
          <div className="md:text-[12px] text-[11px] font-normal text-black font-inter w-full text-center">
            Total Interactions
          </div>
          <div className="md:text-[12px] text-[11px] font-normal text-black font-inter w-full text-center">
            Avg Handle Time
          </div>
          <div className="md:text-[12px] text-[11px] font-normal text-black font-inter w-full text-center">
            CSAT
          </div>
          <div className="md:text-[12px] text-[11px] font-normal text-black font-inter w-full text-center">
            Quality Score
          </div>
          <div className="md:text-[12px] text-[11px] font-normal text-black font-inter w-full text-center">
            Actions
          </div>
        </div>

        {/* Table Body */}
        <div className="flex flex-col gap-0 flex-1 mt-2 overflow-y-auto max-h-[380px] 2xl:max-h-[450px] pr-1">
          {agents.map((agent, index) => (
            <React.Fragment key={index}>
              <div className="w-full cursor-pointer h-[60px] text-center hover:bg-[#F6F9FF] rounded-[12px] flex items-center px-4">
                <div className="w-full flex flex-col md:text-[11px] text-[10px] font-inter text-left">
                  <div className="font-medium text-black">{agent.name}</div>
                  <div className="text-black text-opacity-60 text-[10px]">
                    {agent.role}
                  </div>
                </div>
                <div className="w-full md:text-[11px] text-[10px] font-inter text-black text-center">
                  {agent.role}
                </div>
                <div className="w-full md:text-[11px] text-[10px] font-inter text-black text-center">
                  {agent.interactions}
                </div>
                <div className="w-full md:text-[11px] text-[10px] font-inter text-black text-center">
                  {agent.avg_handle_time}
                </div>
                <div className="w-full md:text-[11px] text-[10px] font-inter text-black text-center">
                  {agent.csat}
                </div>
                <div className="w-full md:text-[11px] text-[10px] font-inter text-black text-center">
                  {agent.quality_score}
                </div>
                <div className="w-full md:text-[11px] text-[10px] font-inter text-center">
                  <button
                    onClick={() => handleViewDetails(agent)} //background: #AA59F7;
                    className="font-medium cursor-pointer text-[#AA59F7] transition-colors hover:text-blue-800"
                  >
                    View Details
                  </button>
                </div>
              </div>
              {index < agents.length - 1 && (
                <div className="w-full border-b z-10 border-[#00000029]"></div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AgentPerformanceTable;
